import React, { useEffect, useState } from 'react';
import PlanCard from './PlanCard';
import PlanCardBulk from './PlanCardBulk';
import { courses } from './plans';
import '../styles/PriceTableSelector.css';

const CoursePlanDisplay = ({ selectedCourse }) => {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    // 指定されたコースに基づいてプランを設定
    if (selectedCourse && courses[selectedCourse]) {
      setPlans(courses[selectedCourse].plans);
    }
  }, [selectedCourse]);

  if (!selectedCourse || !courses[selectedCourse]) {
    return <p>指定されたコースは存在しません。</p>;
  }

  const isSingle = plans.length === 1;
  const availableCategories = courses[selectedCourse].available?.split(',').filter(Boolean);
  const isPlanCard = plans.every(plan => plan.monthly); // PlanCardかどうかの判定

  return (
    <section className="elt-wp-plugin pricing-section">
      {/* カテゴリのリストを表示（存在する場合のみ） */}
      {availableCategories && availableCategories.length > 0 && (
        <div className="categories-container">
          {availableCategories.map((category, index) => (
            <div key={index} className="category-item">
              <img 
                src="/wp-content/uploads/2024/09/shield-check-solid-gradientblue.svg"
                alt="Check" 
                className="category-icon"
              />
              <span>{category}</span>
            </div>
          ))}
        </div>
      )}
      
      <div className={`plan-container plan-card-bulk-container ${isSingle ? 'single' : ''} ${isPlanCard ? 'plan-card-layout' : ''}`}>
        {plans &&
          plans.map((plan, index) => (
            plan.monthly ? 
              <PlanCard key={index} {...plan} /> :
              <PlanCardBulk key={index} {...plan} isSingle={isSingle} />
          ))}
      </div>

      <div className="pricing-notes">
        <div className="notes-container">
          <p className="notes-text">
            ※ 税込表示 <br />
          </p>
          <div className="additional-info">
            <ul className="info-list">
              <li className="info-item">
                <span className="info-border"></span>
                <span className="info-overlay"></span>
                入学金 ０円
              </li>
              <li className="info-item">
                <span className="info-border"></span>
                <span className="info-overlay"></span>
                市販テキスト 約3,000~10,000円
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoursePlanDisplay;

